/**
 * @generated SignedSource<<548d673a95817d7caabe24b4de08bf87>>
 * @relayHash ae57f0e102f7c09991bf117089dc53fd
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ae57f0e102f7c09991bf117089dc53fd

import { ConcreteRequest } from 'relay-runtime';
export type Ch_undoDuplicatePatientsInput = {
  primaryPatientId: string;
};
export type chUndoDuplicatePatientsMutation$variables = {
  input: Ch_undoDuplicatePatientsInput;
};
export type chUndoDuplicatePatientsMutation$data = {
  readonly ch_undoDuplicatePatients: {
    readonly ch_Patient: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type chUndoDuplicatePatientsMutation = {
  response: chUndoDuplicatePatientsMutation$data;
  variables: chUndoDuplicatePatientsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_Patient",
  "kind": "LinkedField",
  "name": "ch_Patient",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chUndoDuplicatePatientsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_undoDuplicatePatientsPayload",
        "kind": "LinkedField",
        "name": "ch_undoDuplicatePatients",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chUndoDuplicatePatientsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_undoDuplicatePatientsPayload",
        "kind": "LinkedField",
        "name": "ch_undoDuplicatePatients",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ae57f0e102f7c09991bf117089dc53fd",
    "metadata": {},
    "name": "chUndoDuplicatePatientsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8aaf18823aed820eeda6c919653b3359";

export default node;
